import React, { useState, useEffect } from "react";
import { Button, Row, Col, Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import moment from "moment";
import "./MesRdv.css";
import ServiceMesRdv from "./ServiceMesRdv/ServiceMesRdv";
//Print data
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../../image/logo2.png";
import Navbar from "../Navbar/Navbar";
import DeleteIcon from "@material-ui/icons/Delete";
import PrintIcon from "@material-ui/icons/Print";
import ListIcon from "@material-ui/icons/List";
//
import DetailRdv from "./detailRdv";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const MesRdv = (props) => {
  const [id, setId] = useState("");

  const [idRdv, setIdRdv] = useState("");

  const [analyses, setAnalyses] = useState("");

  useEffect(() => {
    setId(JSON.parse(sessionStorage.getItem("user")).id);
    GetDataMesRdv();
  }, [id]);

  const GetDataMesRdv = () => {
    ServiceMesRdv.getdatamesrdv(id).then((res) => {
      setInfo(res.data);
    });
  };

  //get analyses by rdv id
  const GetAnalysesByRdvId = (rdvId) => {
    ServiceMesRdv.getAnalysesByRdv(rdvId).then((res) => {
      setAnalyses(res.data);
    });
  };

  const DeleteMesRdv = (id) => {
    ServiceMesRdv.deletemesrdv(id).then((res) => {
      setInfo(INFO.filter((x) => x.id !== id));
      setShow(false);
    });
  };

  const { SearchBar } = Search;

  const [INFO, setInfo] = useState([]);
  //pagination :
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      &thinsp; De {from} à {to} sur {size} RDV
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,

    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "Plus",
        value: INFO.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };

  const columns = [
    {
      dataField: "docteur",
      text: "Etablissement",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "lieux",
      text: "Lieux",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    // {
    //   dataField: "designation",
    //   text: "Désignation",
    //   headerAlign: "center",
    //   align: "center",
    //   sort: true,
    // },
    // {
    //   dataField: "prelevement",
    //   text: "Préstation",
    //   headerAlign: "center",
    //   align: "center",
    //   sort: true,
    // },
    // {
    //   dataField: "price",
    //   text: "prix",
    //   headerAlign: "center",
    //   align: "center",
    //   sort: true,
    // },
    {
      dataField: "date",
      text: "Date",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "hour",
      text: "Heure",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "type",
      text: "Traitement",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
    {
      dataField: "action",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      sort: true,
    },
  ];

  const defaultSorted = [
    {
      dataField: "name",
      dataField: "id",
      dataField: "price",
      order: "desc",
    },
  ];
  // set id rdv
  const printIdRdv = (idRdv) => {
    sessionStorage.setItem(
      "idRdv",
      JSON.stringify({
        id: idRdv,
      })
    );
    window.location.replace("/imprimer");
  };
  // Imprimer le rendez-vous selectionne
  const printRDV = (idRdv) => {
    const printData = INFO.filter((x) => x.id === idRdv);

    var mainLogo = logo;

    var pdf = new jsPDF("p", "mm", "a4");
    //logo
    if (mainLogo) {
      pdf.addImage(mainLogo, "JPEG", 10, 3, 25, 15);
    }
    // pdf header
    pdf.setTextColor(0, 0, 0);
    pdf.text("Prise de rendez-vous en ligne", 70, 30);
    pdf.setFontSize(11);
    pdf.text("Merci de votre confiance", 20, 45);
    pdf.text(
      "Votre rendez-vous est réservé. Votre numéro de référence est le AE3333.",
      20,
      55
    );
    pdf.text(
      `IMPORTANT - Vous devez présenter votre ordonnance médicale et la carte d'identité 
                    au moment du rendez-vous.`,
      20,
      60
    );
    pdf.text(
      `Pour modifier ou annuler ce rendez-vous, contactez-nous par télèphone au +212 05 23 38 64 02.`,
      20,
      70
    );
    pdf.setFontSize(15);
    pdf.text(
      `- Patient : ${printData[0].user.firstName} ${printData[0].user.lastName}`,
      30,
      90
    );
    pdf.text(
      `- Analyse : ${
        printData[0].analyse ? printData[0].analyse.designation : "-"
      }`,
      30,
      100
    );
    pdf.text(`- Type : ${printData[0].type} `, 30, 110);
    pdf.text(
      `- Prix estimé : ${
        printData[0].analyse ? printData[0].analyse.price : "-"
      } `,
      30,
      120
    );
    pdf.text(
      `- Date et heure : le ${moment(printData[0].dateform).format(
        "DD/MM/YYYY"
      )} à ${printData[0].hour}`,
      30,
      130
    );

    //pdf titile
    pdf.setProperties({
      title: "rendez-vous.pdf",
    });
    window.open(pdf.output("bloburl", "confirmation.pdf"));
    // });
  };

  const infouser = [];

  const [showDetail, setShowDetail] = useState(false);
  const ToggleAnalyse = () => {
    setShowDetail(false);
  };
  INFO.map((info) => {
    info.planning.user.laboratory &&
      infouser.push({
        docteur: `${info.planning.user.firstName} ${info.planning.user.lastName}`,
        lieux: (
          <ul className="text-left">
            <li>
              {info.planning.user.laboratory &&
                info.planning.user.laboratory.denomination}
            </li>
            <li>{info.planning.user.laboratory.address}</li>
            <li>{info.planning.user.city.name}</li>
          </ul>
        ),
        // designation: info.planning.designation,
        // prelevement:
        //   analyses && analyses.analyses ? analyses[0].analyses.designation : "-",
        // // info.analyse && info.analyse.designation
        // //   ? info.analyse.designation
        // //   : "-",
        // price: info.analyse && info.analyse.price ? info.analyse.price : "-",
        hour: info.hour,
        date: moment(info.dateform).format("DD/MM/YYYY"),
        type: info.type,
        action: [
          <Button
            className="mr-2 print"
            variant="info"
            onClick={() => {
              GetAnalysesByRdvId(info.id);
              setShowDetail(true);
            }}
          >
            <ListIcon />
          </Button>,
          <Button
            className="mr-2 print"
            variant="info"
            onClick={() => {
              printRDV(info.id);
            }}
          >
            <PrintIcon />
          </Button>,
          <Button
            className="mr-2"
            variant="danger"
            onClick={() => {
              setIdRdv(info.id);
              setShow(true);
            }}
          >
            <DeleteIcon />
          </Button>,
        ],
      });
  });

  // Implement startWith instead of contain
  function customMatchFunc({ searchText, value, column, row }) {
    if (typeof value !== "undefined") {
      return value.startsWith(searchText);
    }
    return false;
  }

  const [show, setShow] = useState(false);

  const Toggle = () => {
    setShow(false);
  };
  return (
    <>
      <Navbar />
      <div className="container">
        <DetailRdv
          analyse={analyses}
          show={showDetail}
          Toggle={ToggleAnalyse}
        />
        {/* <Snackbar open={open} autoHideDuration={6000} onClose={Toggle}>
          <Alert onClose={Toggle} severity="success"></Alert>
        </Snackbar> */}
        <Modal show={show} onHide={Toggle}>
          <Modal.Body>
            <img
              src="https://img.icons8.com/fluent/48/000000/close-window.png"
              style={{ float: "right" }}
              onClick={Toggle}
            />
            <h6
              style={{
                marginTop: "27px",
                marginBottom: "18px",
                textAlign: "center",
              }}
            >
              Êtes-vous sûr d'annuler ce rendez-vous ?
            </h6>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="info" onClick={() => DeleteMesRdv(idRdv)}>
              Oui
            </Button>

            <Button className="mr-auto" variant="danger" onClick={Toggle}>
              Non
            </Button>
          </Modal.Footer>
        </Modal>
        <h3
          style={{
            borderRadius: "0.25em",
            textAlign: "center",
            border: "1px solid purple",
            padding: "0.5em",
            marginTop: "10px",
          }}
        >
          Mes Rendez-vous
        </h3>

        <Col xs={12}>
          <ToolkitProvider
            keyField="id"
            data={infouser}
            columns={columns}
            search={{ customMatchFunc }}
          >
            {(props) => (
              <div>
                <SearchBar {...props.searchProps} />

                <BootstrapTable
                  striped
                  {...props.baseProps}
                  defaultSorted={defaultSorted}
                  pagination={paginationFactory(options)}
                />
              </div>
            )}
          </ToolkitProvider>
        </Col>
      </div>
    </>
  );
};

export default MesRdv;
